/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Kinderwens Dating API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AdminAccount,
  AdminListAccountsParams,
  AdminPendingPhoto,
  AdminRejectPhotoRequest,
  AdminReport,
  AdminSuspendAccountRequest,
  AdminTestResetDailySelection200,
  AdminWhoami,
  AuthResponse,
  AuthUser,
  BlockResponse,
  BlockedUser,
  CampaignMetric,
  CancelMollieSubscription200,
  ChangeEmailRequest,
  ChangePasswordRequest,
  CheckoutSessionResponse,
  CreateBlockRequest,
  CreateCheckoutSessionRequest,
  CreateLikeRequest,
  CreateReportRequest,
  DailyMatchStackResponse,
  ErrorResponse,
  FeedbackEntry,
  GetUnsubscribePreferencesParams,
  HealthStatus,
  KinderwensProfile,
  LikeReceived,
  LikeResult,
  LikeStatus,
  ListProfilesParams,
  LoginRequest,
  Match,
  Message,
  MessageLimitError,
  MessagesResponse,
  MolliePaymentsResponse,
  MollieSubscriptionStatus,
  NotificationCounts,
  PartnerwensProfile,
  Profile,
  ProfileViewer,
  RegisterRequest,
  ReportResponse,
  RequestResetRequest,
  ResetPasswordRequest,
  SendMessageRequest,
  SetCampaignClicksRequest,
  SetTierRequest,
  SetTierResponse,
  SubmitFeedbackRequest,
  SuccessResponse,
  UnsubscribeApplyRequest,
  UnsubscribePreferences,
  UpdateKinderwensProfileRequest,
  UpdatePartnerwensProfileRequest,
  UpdateProfileRequest,
  UpdateSettingsRequest,
  UpdateVideoIntroRequest,
  UpdateVideoIntroResponse,
  UploadUrlRequest,
  UploadUrlResponse,
  VideoUploadUrlRequest,
  VideoUploadUrlResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<HealthStatus>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<HealthStatus>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<HealthStatus>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get today's daily match selection for the current user
 */
export const getListProfilesUrl = (params?: ListProfilesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/profiles?${stringifiedParams}`
    : `/api/profiles`;
};

export const listProfiles = async (
  params?: ListProfilesParams,
  options?: RequestInit,
): Promise<DailyMatchStackResponse> => {
  return customFetch<DailyMatchStackResponse>(getListProfilesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListProfilesQueryKey = (params?: ListProfilesParams) => {
  return [`/api/profiles`, ...(params ? [params] : [])] as const;
};

export const getListProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listProfiles>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListProfilesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProfiles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProfilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProfiles>>> = ({
    signal,
  }) => listProfiles(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProfiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProfilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProfiles>>
>;
export type ListProfilesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get today's daily match selection for the current user
 */

export function useListProfiles<
  TData = Awaited<ReturnType<typeof listProfiles>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListProfilesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProfiles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProfilesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get own profile
 */
export const getGetMyProfileUrl = () => {
  return `/api/profiles/me`;
};

export const getMyProfile = async (options?: RequestInit): Promise<Profile> => {
  return customFetch<Profile>(getGetMyProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyProfileQueryKey = () => {
  return [`/api/profiles/me`] as const;
};

export const getGetMyProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfile>>> = ({
    signal,
  }) => getMyProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyProfile>>
>;
export type GetMyProfileQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get own profile
 */

export function useGetMyProfile<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update own profile
 */
export const getUpdateMyProfileUrl = () => {
  return `/api/profiles/me`;
};

export const updateMyProfile = async (
  updateProfileRequest: UpdateProfileRequest,
  options?: RequestInit,
): Promise<Profile> => {
  return customFetch<Profile>(getUpdateMyProfileUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProfileRequest),
  });
};

export const getUpdateMyProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyProfile>>,
    TError,
    { data: BodyType<UpdateProfileRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyProfile>>,
  TError,
  { data: BodyType<UpdateProfileRequest> },
  TContext
> => {
  const mutationKey = ["updateMyProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyProfile>>,
    { data: BodyType<UpdateProfileRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyProfile>>
>;
export type UpdateMyProfileMutationBody = BodyType<UpdateProfileRequest>;
export type UpdateMyProfileMutationError = ErrorType<unknown>;

/**
 * @summary Update own profile
 */
export const useUpdateMyProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyProfile>>,
    TError,
    { data: BodyType<UpdateProfileRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyProfile>>,
  TError,
  { data: BodyType<UpdateProfileRequest> },
  TContext
> => {
  return useMutation(getUpdateMyProfileMutationOptions(options));
};

/**
 * @summary Get a profile by ID
 */
export const getGetProfileUrl = (id: string) => {
  return `/api/profiles/${id}`;
};

export const getProfile = async (
  id: string,
  options?: RequestInit,
): Promise<Profile> => {
  return customFetch<Profile>(getGetProfileUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetProfileQueryKey = (id: string) => {
  return [`/api/profiles/${id}`] as const;
};

export const getGetProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfileQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({
    signal,
  }) => getProfile(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfile>>
>;
export type GetProfileQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a profile by ID
 */

export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProfileQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get own kinderwens profile
 */
export const getGetMyKinderwensProfileUrl = () => {
  return `/api/kinderwens/me`;
};

export const getMyKinderwensProfile = async (
  options?: RequestInit,
): Promise<KinderwensProfile> => {
  return customFetch<KinderwensProfile>(getGetMyKinderwensProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyKinderwensProfileQueryKey = () => {
  return [`/api/kinderwens/me`] as const;
};

export const getGetMyKinderwensProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyKinderwensProfile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyKinderwensProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyKinderwensProfileQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyKinderwensProfile>>
  > = ({ signal }) => getMyKinderwensProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyKinderwensProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyKinderwensProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyKinderwensProfile>>
>;
export type GetMyKinderwensProfileQueryError = ErrorType<unknown>;

/**
 * @summary Get own kinderwens profile
 */

export function useGetMyKinderwensProfile<
  TData = Awaited<ReturnType<typeof getMyKinderwensProfile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyKinderwensProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyKinderwensProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update own kinderwens profile
 */
export const getUpdateMyKinderwensProfileUrl = () => {
  return `/api/kinderwens/me`;
};

export const updateMyKinderwensProfile = async (
  updateKinderwensProfileRequest: UpdateKinderwensProfileRequest,
  options?: RequestInit,
): Promise<KinderwensProfile> => {
  return customFetch<KinderwensProfile>(getUpdateMyKinderwensProfileUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateKinderwensProfileRequest),
  });
};

export const getUpdateMyKinderwensProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyKinderwensProfile>>,
    TError,
    { data: BodyType<UpdateKinderwensProfileRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyKinderwensProfile>>,
  TError,
  { data: BodyType<UpdateKinderwensProfileRequest> },
  TContext
> => {
  const mutationKey = ["updateMyKinderwensProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyKinderwensProfile>>,
    { data: BodyType<UpdateKinderwensProfileRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyKinderwensProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyKinderwensProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyKinderwensProfile>>
>;
export type UpdateMyKinderwensProfileMutationBody =
  BodyType<UpdateKinderwensProfileRequest>;
export type UpdateMyKinderwensProfileMutationError = ErrorType<unknown>;

/**
 * @summary Update own kinderwens profile
 */
export const useUpdateMyKinderwensProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyKinderwensProfile>>,
    TError,
    { data: BodyType<UpdateKinderwensProfileRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyKinderwensProfile>>,
  TError,
  { data: BodyType<UpdateKinderwensProfileRequest> },
  TContext
> => {
  return useMutation(getUpdateMyKinderwensProfileMutationOptions(options));
};

/**
 * @summary Get own partnerwens profile
 */
export const getGetMyPartnerwensProfileUrl = () => {
  return `/api/partnerwens/me`;
};

export const getMyPartnerwensProfile = async (
  options?: RequestInit,
): Promise<PartnerwensProfile> => {
  return customFetch<PartnerwensProfile>(getGetMyPartnerwensProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyPartnerwensProfileQueryKey = () => {
  return [`/api/partnerwens/me`] as const;
};

export const getGetMyPartnerwensProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPartnerwensProfile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyPartnerwensProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyPartnerwensProfileQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyPartnerwensProfile>>
  > = ({ signal }) => getMyPartnerwensProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyPartnerwensProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyPartnerwensProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyPartnerwensProfile>>
>;
export type GetMyPartnerwensProfileQueryError = ErrorType<unknown>;

/**
 * @summary Get own partnerwens profile
 */

export function useGetMyPartnerwensProfile<
  TData = Awaited<ReturnType<typeof getMyPartnerwensProfile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyPartnerwensProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyPartnerwensProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update own partnerwens profile
 */
export const getUpdateMyPartnerwensProfileUrl = () => {
  return `/api/partnerwens/me`;
};

export const updateMyPartnerwensProfile = async (
  updatePartnerwensProfileRequest: UpdatePartnerwensProfileRequest,
  options?: RequestInit,
): Promise<PartnerwensProfile> => {
  return customFetch<PartnerwensProfile>(getUpdateMyPartnerwensProfileUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePartnerwensProfileRequest),
  });
};

export const getUpdateMyPartnerwensProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyPartnerwensProfile>>,
    TError,
    { data: BodyType<UpdatePartnerwensProfileRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyPartnerwensProfile>>,
  TError,
  { data: BodyType<UpdatePartnerwensProfileRequest> },
  TContext
> => {
  const mutationKey = ["updateMyPartnerwensProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyPartnerwensProfile>>,
    { data: BodyType<UpdatePartnerwensProfileRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyPartnerwensProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyPartnerwensProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyPartnerwensProfile>>
>;
export type UpdateMyPartnerwensProfileMutationBody =
  BodyType<UpdatePartnerwensProfileRequest>;
export type UpdateMyPartnerwensProfileMutationError = ErrorType<unknown>;

/**
 * @summary Update own partnerwens profile
 */
export const useUpdateMyPartnerwensProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyPartnerwensProfile>>,
    TError,
    { data: BodyType<UpdatePartnerwensProfileRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyPartnerwensProfile>>,
  TError,
  { data: BodyType<UpdatePartnerwensProfileRequest> },
  TContext
> => {
  return useMutation(getUpdateMyPartnerwensProfileMutationOptions(options));
};

/**
 * @summary Get unread message count and new match count
 */
export const getGetNotificationCountsUrl = () => {
  return `/api/matches/notification-counts`;
};

export const getNotificationCounts = async (
  options?: RequestInit,
): Promise<NotificationCounts> => {
  return customFetch<NotificationCounts>(getGetNotificationCountsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetNotificationCountsQueryKey = () => {
  return [`/api/matches/notification-counts`] as const;
};

export const getGetNotificationCountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationCounts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationCounts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationCountsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationCounts>>
  > = ({ signal }) => getNotificationCounts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationCounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationCountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationCounts>>
>;
export type GetNotificationCountsQueryError = ErrorType<unknown>;

/**
 * @summary Get unread message count and new match count
 */

export function useGetNotificationCounts<
  TData = Awaited<ReturnType<typeof getNotificationCounts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationCounts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationCountsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get like gating status for current user
 */
export const getGetLikeStatusUrl = () => {
  return `/api/matches/like-status`;
};

export const getLikeStatus = async (
  options?: RequestInit,
): Promise<LikeStatus> => {
  return customFetch<LikeStatus>(getGetLikeStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetLikeStatusQueryKey = () => {
  return [`/api/matches/like-status`] as const;
};

export const getGetLikeStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getLikeStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLikeStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLikeStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLikeStatus>>> = ({
    signal,
  }) => getLikeStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLikeStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLikeStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLikeStatus>>
>;
export type GetLikeStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get like gating status for current user
 */

export function useGetLikeStatus<
  TData = Awaited<ReturnType<typeof getLikeStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLikeStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLikeStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a Mollie payment (one-off Serieus or first-payment for Premium/Gold mandate)
 */
export const getCreateMolliePaymentUrl = () => {
  return `/api/mollie/create-payment`;
};

export const createMolliePayment = async (
  createCheckoutSessionRequest: CreateCheckoutSessionRequest,
  options?: RequestInit,
): Promise<CheckoutSessionResponse> => {
  return customFetch<CheckoutSessionResponse>(getCreateMolliePaymentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCheckoutSessionRequest),
  });
};

export const getCreateMolliePaymentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMolliePayment>>,
    TError,
    { data: BodyType<CreateCheckoutSessionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMolliePayment>>,
  TError,
  { data: BodyType<CreateCheckoutSessionRequest> },
  TContext
> => {
  const mutationKey = ["createMolliePayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMolliePayment>>,
    { data: BodyType<CreateCheckoutSessionRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createMolliePayment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMolliePaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMolliePayment>>
>;
export type CreateMolliePaymentMutationBody =
  BodyType<CreateCheckoutSessionRequest>;
export type CreateMolliePaymentMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a Mollie payment (one-off Serieus or first-payment for Premium/Gold mandate)
 */
export const useCreateMolliePayment = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMolliePayment>>,
    TError,
    { data: BodyType<CreateCheckoutSessionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMolliePayment>>,
  TError,
  { data: BodyType<CreateCheckoutSessionRequest> },
  TContext
> => {
  return useMutation(getCreateMolliePaymentMutationOptions(options));
};

/**
 * @summary Cancel the current Mollie subscription
 */
export const getCancelMollieSubscriptionUrl = () => {
  return `/api/mollie/cancel-subscription`;
};

export const cancelMollieSubscription = async (
  options?: RequestInit,
): Promise<CancelMollieSubscription200> => {
  return customFetch<CancelMollieSubscription200>(
    getCancelMollieSubscriptionUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCancelMollieSubscriptionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMollieSubscription>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelMollieSubscription>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["cancelMollieSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelMollieSubscription>>,
    void
  > = () => {
    return cancelMollieSubscription(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelMollieSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelMollieSubscription>>
>;

export type CancelMollieSubscriptionMutationError = ErrorType<unknown>;

/**
 * @summary Cancel the current Mollie subscription
 */
export const useCancelMollieSubscription = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMollieSubscription>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelMollieSubscription>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCancelMollieSubscriptionMutationOptions(options));
};

/**
 * @summary Get current Mollie subscription status
 */
export const getGetMollieSubscriptionStatusUrl = () => {
  return `/api/mollie/subscription-status`;
};

export const getMollieSubscriptionStatus = async (
  options?: RequestInit,
): Promise<MollieSubscriptionStatus> => {
  return customFetch<MollieSubscriptionStatus>(
    getGetMollieSubscriptionStatusUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetMollieSubscriptionStatusQueryKey = () => {
  return [`/api/mollie/subscription-status`] as const;
};

export const getGetMollieSubscriptionStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getMollieSubscriptionStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMollieSubscriptionStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMollieSubscriptionStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMollieSubscriptionStatus>>
  > = ({ signal }) =>
    getMollieSubscriptionStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMollieSubscriptionStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMollieSubscriptionStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMollieSubscriptionStatus>>
>;
export type GetMollieSubscriptionStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get current Mollie subscription status
 */

export function useGetMollieSubscriptionStatus<
  TData = Awaited<ReturnType<typeof getMollieSubscriptionStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMollieSubscriptionStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMollieSubscriptionStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the user's recent Mollie payments (max 12)
 */
export const getListMolliePaymentsUrl = () => {
  return `/api/mollie/payments`;
};

export const listMolliePayments = async (
  options?: RequestInit,
): Promise<MolliePaymentsResponse> => {
  return customFetch<MolliePaymentsResponse>(getListMolliePaymentsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMolliePaymentsQueryKey = () => {
  return [`/api/mollie/payments`] as const;
};

export const getListMolliePaymentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMolliePayments>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMolliePayments>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMolliePaymentsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMolliePayments>>
  > = ({ signal }) => listMolliePayments({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMolliePayments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMolliePaymentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMolliePayments>>
>;
export type ListMolliePaymentsQueryError = ErrorType<unknown>;

/**
 * @summary List the user's recent Mollie payments (max 12)
 */

export function useListMolliePayments<
  TData = Awaited<ReturnType<typeof listMolliePayments>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMolliePayments>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMolliePaymentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List own matches
 */
export const getListMatchesUrl = () => {
  return `/api/matches`;
};

export const listMatches = async (options?: RequestInit): Promise<Match[]> => {
  return customFetch<Match[]>(getListMatchesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMatchesQueryKey = () => {
  return [`/api/matches`] as const;
};

export const getListMatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMatches>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMatchesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMatches>>> = ({
    signal,
  }) => listMatches({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMatches>>
>;
export type ListMatchesQueryError = ErrorType<unknown>;

/**
 * @summary List own matches
 */

export function useListMatches<
  TData = Awaited<ReturnType<typeof listMatches>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMatches>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMatchesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Like or pass a profile
 */
export const getCreateLikeUrl = () => {
  return `/api/matches`;
};

export const createLike = async (
  createLikeRequest: CreateLikeRequest,
  options?: RequestInit,
): Promise<LikeResult> => {
  return customFetch<LikeResult>(getCreateLikeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createLikeRequest),
  });
};

export const getCreateLikeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLike>>,
    TError,
    { data: BodyType<CreateLikeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLike>>,
  TError,
  { data: BodyType<CreateLikeRequest> },
  TContext
> => {
  const mutationKey = ["createLike"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLike>>,
    { data: BodyType<CreateLikeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createLike(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLikeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLike>>
>;
export type CreateLikeMutationBody = BodyType<CreateLikeRequest>;
export type CreateLikeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Like or pass a profile
 */
export const useCreateLike = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLike>>,
    TError,
    { data: BodyType<CreateLikeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLike>>,
  TError,
  { data: BodyType<CreateLikeRequest> },
  TContext
> => {
  return useMutation(getCreateLikeMutationOptions(options));
};

/**
 * @summary List messages for a match
 */
export const getListMessagesUrl = (matchId: string) => {
  return `/api/messages/${matchId}`;
};

export const listMessages = async (
  matchId: string,
  options?: RequestInit,
): Promise<MessagesResponse> => {
  return customFetch<MessagesResponse>(getListMessagesUrl(matchId), {
    ...options,
    method: "GET",
  });
};

export const getListMessagesQueryKey = (matchId: string) => {
  return [`/api/messages/${matchId}`] as const;
};

export const getListMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMessages>>,
  TError = ErrorType<unknown>,
>(
  matchId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMessagesQueryKey(matchId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMessages>>> = ({
    signal,
  }) => listMessages(matchId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!matchId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMessages>>
>;
export type ListMessagesQueryError = ErrorType<unknown>;

/**
 * @summary List messages for a match
 */

export function useListMessages<
  TData = Awaited<ReturnType<typeof listMessages>>,
  TError = ErrorType<unknown>,
>(
  matchId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMessagesQueryOptions(matchId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Send a message
 */
export const getSendMessageUrl = (matchId: string) => {
  return `/api/messages/${matchId}`;
};

export const sendMessage = async (
  matchId: string,
  sendMessageRequest: SendMessageRequest,
  options?: RequestInit,
): Promise<Message> => {
  return customFetch<Message>(getSendMessageUrl(matchId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendMessageRequest),
  });
};

export const getSendMessageMutationOptions = <
  TError = ErrorType<MessageLimitError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessage>>,
    TError,
    { matchId: string; data: BodyType<SendMessageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { matchId: string; data: BodyType<SendMessageRequest> },
  TContext
> => {
  const mutationKey = ["sendMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessage>>,
    { matchId: string; data: BodyType<SendMessageRequest> }
  > = (props) => {
    const { matchId, data } = props ?? {};

    return sendMessage(matchId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessage>>
>;
export type SendMessageMutationBody = BodyType<SendMessageRequest>;
export type SendMessageMutationError = ErrorType<MessageLimitError>;

/**
 * @summary Send a message
 */
export const useSendMessage = <
  TError = ErrorType<MessageLimitError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessage>>,
    TError,
    { matchId: string; data: BodyType<SendMessageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { matchId: string; data: BodyType<SendMessageRequest> },
  TContext
> => {
  return useMutation(getSendMessageMutationOptions(options));
};

/**
 * @summary Mark all messages in a match as read
 */
export const getMarkMessagesReadUrl = (matchId: string) => {
  return `/api/messages/${matchId}/read`;
};

export const markMessagesRead = async (
  matchId: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getMarkMessagesReadUrl(matchId), {
    ...options,
    method: "PUT",
  });
};

export const getMarkMessagesReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markMessagesRead>>,
    TError,
    { matchId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markMessagesRead>>,
  TError,
  { matchId: string },
  TContext
> => {
  const mutationKey = ["markMessagesRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markMessagesRead>>,
    { matchId: string }
  > = (props) => {
    const { matchId } = props ?? {};

    return markMessagesRead(matchId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkMessagesReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markMessagesRead>>
>;

export type MarkMessagesReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark all messages in a match as read
 */
export const useMarkMessagesRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markMessagesRead>>,
    TError,
    { matchId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markMessagesRead>>,
  TError,
  { matchId: string },
  TContext
> => {
  return useMutation(getMarkMessagesReadMutationOptions(options));
};

/**
 * @summary Request a presigned URL for file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponse> => {
  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary Serve a public asset
 */
export const getGetPublicObjectUrl = (filePath: string) => {
  return `/api/storage/public-objects/${filePath}`;
};

export const getPublicObject = async (
  filePath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetPublicObjectUrl(filePath), {
    ...options,
    method: "GET",
  });
};

export const getGetPublicObjectQueryKey = (filePath: string) => {
  return [`/api/storage/public-objects/${filePath}`] as const;
};

export const getGetPublicObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorResponse>,
>(
  filePath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({
    signal,
  }) => getPublicObject(filePath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!filePath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicObject>>
>;
export type GetPublicObjectQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Serve a public asset
 */

export function useGetPublicObject<
  TData = Awaited<ReturnType<typeof getPublicObject>>,
  TError = ErrorType<ErrorResponse>,
>(
  filePath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPublicObjectQueryOptions(filePath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Serve an uploaded object
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Serve an uploaded object
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<ErrorResponse>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register new user
 */
export const getRegisterUrl = () => {
  return `/api/auth/register`;
};

export const register = async (
  registerRequest: RegisterRequest,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getRegisterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerRequest),
  });
};

export const getRegisterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterRequest> },
  TContext
> => {
  const mutationKey = ["register"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof register>>,
    { data: BodyType<RegisterRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return register(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof register>>
>;
export type RegisterMutationBody = BodyType<RegisterRequest>;
export type RegisterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Register new user
 */
export const useRegister = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterRequest> },
  TContext
> => {
  return useMutation(getRegisterMutationOptions(options));
};

/**
 * @summary Login
 */
export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  loginRequest: LoginRequest,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginRequest),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginRequest>;
export type LoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Login
 */
export const useLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Logout
 */
export const getLogoutUrl = () => {
  return `/api/auth/logout`;
};

export const logout = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Logout
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options));
};

/**
 * @summary Request a password reset link
 */
export const getRequestPasswordResetUrl = () => {
  return `/api/auth/request-reset`;
};

export const requestPasswordReset = async (
  requestResetRequest: RequestResetRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getRequestPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(requestResetRequest),
  });
};

export const getRequestPasswordResetMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: BodyType<RequestResetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: BodyType<RequestResetRequest> },
  TContext
> => {
  const mutationKey = ["requestPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    { data: BodyType<RequestResetRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestPasswordReset>>
>;
export type RequestPasswordResetMutationBody = BodyType<RequestResetRequest>;
export type RequestPasswordResetMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Request a password reset link
 */
export const useRequestPasswordReset = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: BodyType<RequestResetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: BodyType<RequestResetRequest> },
  TContext
> => {
  return useMutation(getRequestPasswordResetMutationOptions(options));
};

/**
 * @summary Reset password with token
 */
export const getResetPasswordUrl = () => {
  return `/api/auth/reset-password`;
};

export const resetPassword = async (
  resetPasswordRequest: ResetPasswordRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getResetPasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resetPasswordRequest),
  });
};

export const getResetPasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    { data: BodyType<ResetPasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  { data: BodyType<ResetPasswordRequest> },
  TContext
> => {
  const mutationKey = ["resetPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPassword>>,
    { data: BodyType<ResetPasswordRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return resetPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetPassword>>
>;
export type ResetPasswordMutationBody = BodyType<ResetPasswordRequest>;
export type ResetPasswordMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Reset password with token
 */
export const useResetPassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    { data: BodyType<ResetPasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  { data: BodyType<ResetPasswordRequest> },
  TContext
> => {
  return useMutation(getResetPasswordMutationOptions(options));
};

/**
 * @summary Get current authenticated user
 */
export const getGetAuthUserUrl = () => {
  return `/api/auth/me`;
};

export const getAuthUser = async (options?: RequestInit): Promise<AuthUser> => {
  return customFetch<AuthUser>(getGetAuthUserUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAuthUserQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetAuthUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAuthUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuthUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthUser>>> = ({
    signal,
  }) => getAuthUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAuthUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthUser>>
>;
export type GetAuthUserQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current authenticated user
 */

export function useGetAuthUser<
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAuthUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAuthUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Change email address
 */
export const getChangeEmailUrl = () => {
  return `/api/auth/email`;
};

export const changeEmail = async (
  changeEmailRequest: ChangeEmailRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getChangeEmailUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changeEmailRequest),
  });
};

export const getChangeEmailMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeEmail>>,
    TError,
    { data: BodyType<ChangeEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeEmail>>,
  TError,
  { data: BodyType<ChangeEmailRequest> },
  TContext
> => {
  const mutationKey = ["changeEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeEmail>>,
    { data: BodyType<ChangeEmailRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return changeEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeEmail>>
>;
export type ChangeEmailMutationBody = BodyType<ChangeEmailRequest>;
export type ChangeEmailMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Change email address
 */
export const useChangeEmail = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeEmail>>,
    TError,
    { data: BodyType<ChangeEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeEmail>>,
  TError,
  { data: BodyType<ChangeEmailRequest> },
  TContext
> => {
  return useMutation(getChangeEmailMutationOptions(options));
};

/**
 * @summary Change password
 */
export const getChangePasswordUrl = () => {
  return `/api/auth/password`;
};

export const changePassword = async (
  changePasswordRequest: ChangePasswordRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getChangePasswordUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changePasswordRequest),
  });
};

export const getChangePasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: BodyType<ChangePasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: BodyType<ChangePasswordRequest> },
  TContext
> => {
  const mutationKey = ["changePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePassword>>,
    { data: BodyType<ChangePasswordRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return changePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePassword>>
>;
export type ChangePasswordMutationBody = BodyType<ChangePasswordRequest>;
export type ChangePasswordMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Change password
 */
export const useChangePassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: BodyType<ChangePasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: BodyType<ChangePasswordRequest> },
  TContext
> => {
  return useMutation(getChangePasswordMutationOptions(options));
};

/**
 * @summary Delete user account
 */
export const getDeleteAccountUrl = () => {
  return `/api/auth/account`;
};

export const deleteAccount = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteAccountUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccount>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccount>>,
    void
  > = () => {
    return deleteAccount(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccount>>
>;

export type DeleteAccountMutationError = ErrorType<unknown>;

/**
 * @summary Delete user account
 */
export const useDeleteAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccount>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteAccountMutationOptions(options));
};

/**
 * @summary Report a profile
 */
export const getCreateReportUrl = () => {
  return `/api/reports`;
};

export const createReport = async (
  createReportRequest: CreateReportRequest,
  options?: RequestInit,
): Promise<ReportResponse> => {
  return customFetch<ReportResponse>(getCreateReportUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createReportRequest),
  });
};

export const getCreateReportMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReport>>,
    TError,
    { data: BodyType<CreateReportRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createReport>>,
  TError,
  { data: BodyType<CreateReportRequest> },
  TContext
> => {
  const mutationKey = ["createReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReport>>,
    { data: BodyType<CreateReportRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createReport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof createReport>>
>;
export type CreateReportMutationBody = BodyType<CreateReportRequest>;
export type CreateReportMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Report a profile
 */
export const useCreateReport = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReport>>,
    TError,
    { data: BodyType<CreateReportRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createReport>>,
  TError,
  { data: BodyType<CreateReportRequest> },
  TContext
> => {
  return useMutation(getCreateReportMutationOptions(options));
};

/**
 * @summary Dev/QA: regenereer de dagelijkse match-selectie van de huidige gebruiker (alleen actief als ENABLE_TEST_ENDPOINTS=true en NODE_ENV!=production).
 */
export const getAdminTestResetDailySelectionUrl = () => {
  return `/api/admin/_test/reset-daily-selection`;
};

export const adminTestResetDailySelection = async (
  options?: RequestInit,
): Promise<AdminTestResetDailySelection200> => {
  return customFetch<AdminTestResetDailySelection200>(
    getAdminTestResetDailySelectionUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getAdminTestResetDailySelectionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminTestResetDailySelection>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminTestResetDailySelection>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["adminTestResetDailySelection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminTestResetDailySelection>>,
    void
  > = () => {
    return adminTestResetDailySelection(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTestResetDailySelectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminTestResetDailySelection>>
>;

export type AdminTestResetDailySelectionMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Dev/QA: regenereer de dagelijkse match-selectie van de huidige gebruiker (alleen actief als ENABLE_TEST_ENDPOINTS=true en NODE_ENV!=production).
 */
export const useAdminTestResetDailySelection = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminTestResetDailySelection>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminTestResetDailySelection>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getAdminTestResetDailySelectionMutationOptions(options));
};

/**
 * @summary Verify current user is admin
 */
export const getAdminWhoamiUrl = () => {
  return `/api/admin/me`;
};

export const adminWhoami = async (
  options?: RequestInit,
): Promise<AdminWhoami> => {
  return customFetch<AdminWhoami>(getAdminWhoamiUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminWhoamiQueryKey = () => {
  return [`/api/admin/me`] as const;
};

export const getAdminWhoamiQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWhoami>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminWhoami>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWhoamiQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminWhoami>>> = ({
    signal,
  }) => adminWhoami({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWhoami>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminWhoamiQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWhoami>>
>;
export type AdminWhoamiQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Verify current user is admin
 */

export function useAdminWhoami<
  TData = Awaited<ReturnType<typeof adminWhoami>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminWhoami>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminWhoamiQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List photos awaiting moderation
 */
export const getAdminListPendingPhotosUrl = () => {
  return `/api/admin/photos/pending`;
};

export const adminListPendingPhotos = async (
  options?: RequestInit,
): Promise<AdminPendingPhoto[]> => {
  return customFetch<AdminPendingPhoto[]>(getAdminListPendingPhotosUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListPendingPhotosQueryKey = () => {
  return [`/api/admin/photos/pending`] as const;
};

export const getAdminListPendingPhotosQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListPendingPhotos>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPendingPhotos>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListPendingPhotosQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListPendingPhotos>>
  > = ({ signal }) => adminListPendingPhotos({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListPendingPhotos>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListPendingPhotosQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListPendingPhotos>>
>;
export type AdminListPendingPhotosQueryError = ErrorType<unknown>;

/**
 * @summary List photos awaiting moderation
 */

export function useAdminListPendingPhotos<
  TData = Awaited<ReturnType<typeof adminListPendingPhotos>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPendingPhotos>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListPendingPhotosQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Approve a pending photo
 */
export const getAdminApprovePhotoUrl = (id: string) => {
  return `/api/admin/photos/${id}/approve`;
};

export const adminApprovePhoto = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getAdminApprovePhotoUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAdminApprovePhotoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminApprovePhoto>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminApprovePhoto>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["adminApprovePhoto"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminApprovePhoto>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminApprovePhoto(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminApprovePhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminApprovePhoto>>
>;

export type AdminApprovePhotoMutationError = ErrorType<unknown>;

/**
 * @summary Approve a pending photo
 */
export const useAdminApprovePhoto = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminApprovePhoto>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminApprovePhoto>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAdminApprovePhotoMutationOptions(options));
};

/**
 * @summary Reject a pending photo
 */
export const getAdminRejectPhotoUrl = (id: string) => {
  return `/api/admin/photos/${id}/reject`;
};

export const adminRejectPhoto = async (
  id: string,
  adminRejectPhotoRequest: AdminRejectPhotoRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getAdminRejectPhotoUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminRejectPhotoRequest),
  });
};

export const getAdminRejectPhotoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRejectPhoto>>,
    TError,
    { id: string; data: BodyType<AdminRejectPhotoRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRejectPhoto>>,
  TError,
  { id: string; data: BodyType<AdminRejectPhotoRequest> },
  TContext
> => {
  const mutationKey = ["adminRejectPhoto"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRejectPhoto>>,
    { id: string; data: BodyType<AdminRejectPhotoRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminRejectPhoto(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminRejectPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRejectPhoto>>
>;
export type AdminRejectPhotoMutationBody = BodyType<AdminRejectPhotoRequest>;
export type AdminRejectPhotoMutationError = ErrorType<unknown>;

/**
 * @summary Reject a pending photo
 */
export const useAdminRejectPhoto = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRejectPhoto>>,
    TError,
    { id: string; data: BodyType<AdminRejectPhotoRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminRejectPhoto>>,
  TError,
  { id: string; data: BodyType<AdminRejectPhotoRequest> },
  TContext
> => {
  return useMutation(getAdminRejectPhotoMutationOptions(options));
};

/**
 * @summary List open reports
 */
export const getAdminListReportsUrl = () => {
  return `/api/admin/reports`;
};

export const adminListReports = async (
  options?: RequestInit,
): Promise<AdminReport[]> => {
  return customFetch<AdminReport[]>(getAdminListReportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListReportsQueryKey = () => {
  return [`/api/admin/reports`] as const;
};

export const getAdminListReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListReports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListReportsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListReports>>
  > = ({ signal }) => adminListReports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListReports>>
>;
export type AdminListReportsQueryError = ErrorType<unknown>;

/**
 * @summary List open reports
 */

export function useAdminListReports<
  TData = Awaited<ReturnType<typeof adminListReports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListReportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Close (delete) a report
 */
export const getAdminCloseReportUrl = (id: string) => {
  return `/api/admin/reports/${id}`;
};

export const adminCloseReport = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getAdminCloseReportUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getAdminCloseReportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCloseReport>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCloseReport>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["adminCloseReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCloseReport>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminCloseReport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCloseReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCloseReport>>
>;

export type AdminCloseReportMutationError = ErrorType<unknown>;

/**
 * @summary Close (delete) a report
 */
export const useAdminCloseReport = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCloseReport>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminCloseReport>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAdminCloseReportMutationOptions(options));
};

/**
 * @summary List acquisition campaigns with signup attribution
 */
export const getAdminListCampaignsUrl = () => {
  return `/api/admin/campaigns`;
};

export const adminListCampaigns = async (
  options?: RequestInit,
): Promise<CampaignMetric[]> => {
  return customFetch<CampaignMetric[]>(getAdminListCampaignsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListCampaignsQueryKey = () => {
  return [`/api/admin/campaigns`] as const;
};

export const getAdminListCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListCampaigns>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListCampaigns>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListCampaignsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListCampaigns>>
  > = ({ signal }) => adminListCampaigns({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListCampaigns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListCampaigns>>
>;
export type AdminListCampaignsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List acquisition campaigns with signup attribution
 */

export function useAdminListCampaigns<
  TData = Awaited<ReturnType<typeof adminListCampaigns>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListCampaigns>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListCampaignsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert the click count for a campaign (sourced from Resend)
 */
export const getAdminSetCampaignClicksUrl = () => {
  return `/api/admin/campaigns/clicks`;
};

export const adminSetCampaignClicks = async (
  setCampaignClicksRequest: SetCampaignClicksRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getAdminSetCampaignClicksUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setCampaignClicksRequest),
  });
};

export const getAdminSetCampaignClicksMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetCampaignClicks>>,
    TError,
    { data: BodyType<SetCampaignClicksRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetCampaignClicks>>,
  TError,
  { data: BodyType<SetCampaignClicksRequest> },
  TContext
> => {
  const mutationKey = ["adminSetCampaignClicks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetCampaignClicks>>,
    { data: BodyType<SetCampaignClicksRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminSetCampaignClicks(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetCampaignClicksMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetCampaignClicks>>
>;
export type AdminSetCampaignClicksMutationBody =
  BodyType<SetCampaignClicksRequest>;
export type AdminSetCampaignClicksMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upsert the click count for a campaign (sourced from Resend)
 */
export const useAdminSetCampaignClicks = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetCampaignClicks>>,
    TError,
    { data: BodyType<SetCampaignClicksRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetCampaignClicks>>,
  TError,
  { data: BodyType<SetCampaignClicksRequest> },
  TContext
> => {
  return useMutation(getAdminSetCampaignClicksMutationOptions(options));
};

/**
 * @summary List user accounts (with filters)
 */
export const getAdminListAccountsUrl = (params?: AdminListAccountsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/accounts?${stringifiedParams}`
    : `/api/admin/accounts`;
};

export const adminListAccounts = async (
  params?: AdminListAccountsParams,
  options?: RequestInit,
): Promise<AdminAccount[]> => {
  return customFetch<AdminAccount[]>(getAdminListAccountsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getAdminListAccountsQueryKey = (
  params?: AdminListAccountsParams,
) => {
  return [`/api/admin/accounts`, ...(params ? [params] : [])] as const;
};

export const getAdminListAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListAccounts>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminListAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListAccounts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListAccountsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListAccounts>>
  > = ({ signal }) => adminListAccounts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListAccounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListAccounts>>
>;
export type AdminListAccountsQueryError = ErrorType<unknown>;

/**
 * @summary List user accounts (with filters)
 */

export function useAdminListAccounts<
  TData = Awaited<ReturnType<typeof adminListAccounts>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminListAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListAccounts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListAccountsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Suspend an account
 */
export const getAdminSuspendAccountUrl = (id: string) => {
  return `/api/admin/accounts/${id}/suspend`;
};

export const adminSuspendAccount = async (
  id: string,
  adminSuspendAccountRequest: AdminSuspendAccountRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getAdminSuspendAccountUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminSuspendAccountRequest),
  });
};

export const getAdminSuspendAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSuspendAccount>>,
    TError,
    { id: string; data: BodyType<AdminSuspendAccountRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSuspendAccount>>,
  TError,
  { id: string; data: BodyType<AdminSuspendAccountRequest> },
  TContext
> => {
  const mutationKey = ["adminSuspendAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSuspendAccount>>,
    { id: string; data: BodyType<AdminSuspendAccountRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminSuspendAccount(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSuspendAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSuspendAccount>>
>;
export type AdminSuspendAccountMutationBody =
  BodyType<AdminSuspendAccountRequest>;
export type AdminSuspendAccountMutationError = ErrorType<unknown>;

/**
 * @summary Suspend an account
 */
export const useAdminSuspendAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSuspendAccount>>,
    TError,
    { id: string; data: BodyType<AdminSuspendAccountRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSuspendAccount>>,
  TError,
  { id: string; data: BodyType<AdminSuspendAccountRequest> },
  TContext
> => {
  return useMutation(getAdminSuspendAccountMutationOptions(options));
};

/**
 * @summary Reactivate a suspended account
 */
export const getAdminReactivateAccountUrl = (id: string) => {
  return `/api/admin/accounts/${id}/reactivate`;
};

export const adminReactivateAccount = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getAdminReactivateAccountUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAdminReactivateAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReactivateAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminReactivateAccount>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["adminReactivateAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminReactivateAccount>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminReactivateAccount(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminReactivateAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminReactivateAccount>>
>;

export type AdminReactivateAccountMutationError = ErrorType<unknown>;

/**
 * @summary Reactivate a suspended account
 */
export const useAdminReactivateAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReactivateAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminReactivateAccount>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAdminReactivateAccountMutationOptions(options));
};

/**
 * @summary Permanently delete an account
 */
export const getAdminDeleteAccountUrl = (id: string) => {
  return `/api/admin/accounts/${id}`;
};

export const adminDeleteAccount = async (
  id: string,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getAdminDeleteAccountUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getAdminDeleteAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteAccount>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["adminDeleteAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteAccount>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminDeleteAccount(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteAccount>>
>;

export type AdminDeleteAccountMutationError = ErrorType<unknown>;

/**
 * @summary Permanently delete an account
 */
export const useAdminDeleteAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteAccount>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAdminDeleteAccountMutationOptions(options));
};

/**
 * @summary List users blocked by current user
 */
export const getListBlocksUrl = () => {
  return `/api/blocks`;
};

export const listBlocks = async (
  options?: RequestInit,
): Promise<BlockedUser[]> => {
  return customFetch<BlockedUser[]>(getListBlocksUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListBlocksQueryKey = () => {
  return [`/api/blocks`] as const;
};

export const getListBlocksQueryOptions = <
  TData = Awaited<ReturnType<typeof listBlocks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBlocks>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBlocksQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBlocks>>> = ({
    signal,
  }) => listBlocks({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBlocks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBlocksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBlocks>>
>;
export type ListBlocksQueryError = ErrorType<unknown>;

/**
 * @summary List users blocked by current user
 */

export function useListBlocks<
  TData = Awaited<ReturnType<typeof listBlocks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBlocks>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBlocksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Block a user
 */
export const getCreateBlockUrl = () => {
  return `/api/blocks`;
};

export const createBlock = async (
  createBlockRequest: CreateBlockRequest,
  options?: RequestInit,
): Promise<BlockResponse> => {
  return customFetch<BlockResponse>(getCreateBlockUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBlockRequest),
  });
};

export const getCreateBlockMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBlock>>,
    TError,
    { data: BodyType<CreateBlockRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBlock>>,
  TError,
  { data: BodyType<CreateBlockRequest> },
  TContext
> => {
  const mutationKey = ["createBlock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBlock>>,
    { data: BodyType<CreateBlockRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createBlock(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBlock>>
>;
export type CreateBlockMutationBody = BodyType<CreateBlockRequest>;
export type CreateBlockMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Block a user
 */
export const useCreateBlock = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBlock>>,
    TError,
    { data: BodyType<CreateBlockRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBlock>>,
  TError,
  { data: BodyType<CreateBlockRequest> },
  TContext
> => {
  return useMutation(getCreateBlockMutationOptions(options));
};

/**
 * @summary Unblock a user
 */
export const getDeleteBlockUrl = (userId: string) => {
  return `/api/blocks/${userId}`;
};

export const deleteBlock = async (
  userId: string,
  options?: RequestInit,
): Promise<BlockResponse> => {
  return customFetch<BlockResponse>(getDeleteBlockUrl(userId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBlockMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBlock>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBlock>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ["deleteBlock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBlock>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return deleteBlock(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBlock>>
>;

export type DeleteBlockMutationError = ErrorType<unknown>;

/**
 * @summary Unblock a user
 */
export const useDeleteBlock = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBlock>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBlock>>,
  TError,
  { userId: string },
  TContext
> => {
  return useMutation(getDeleteBlockMutationOptions(options));
};

/**
 * @summary List recent profile viewers (Premium/Gold only)
 */
export const getGetMyProfileViewersUrl = () => {
  return `/api/profiles/me/profile-viewers`;
};

export const getMyProfileViewers = async (
  options?: RequestInit,
): Promise<ProfileViewer[]> => {
  return customFetch<ProfileViewer[]>(getGetMyProfileViewersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyProfileViewersQueryKey = () => {
  return [`/api/profiles/me/profile-viewers`] as const;
};

export const getGetMyProfileViewersQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyProfileViewers>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfileViewers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyProfileViewersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyProfileViewers>>
  > = ({ signal }) => getMyProfileViewers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfileViewers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyProfileViewersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyProfileViewers>>
>;
export type GetMyProfileViewersQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List recent profile viewers (Premium/Gold only)
 */

export function useGetMyProfileViewers<
  TData = Awaited<ReturnType<typeof getMyProfileViewers>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfileViewers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyProfileViewersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List incoming likes not yet matched (Gold only)
 */
export const getGetMyLikesReceivedUrl = () => {
  return `/api/profiles/me/likes-received`;
};

export const getMyLikesReceived = async (
  options?: RequestInit,
): Promise<LikeReceived[]> => {
  return customFetch<LikeReceived[]>(getGetMyLikesReceivedUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyLikesReceivedQueryKey = () => {
  return [`/api/profiles/me/likes-received`] as const;
};

export const getGetMyLikesReceivedQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyLikesReceived>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyLikesReceived>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyLikesReceivedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyLikesReceived>>
  > = ({ signal }) => getMyLikesReceived({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyLikesReceived>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyLikesReceivedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyLikesReceived>>
>;
export type GetMyLikesReceivedQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List incoming likes not yet matched (Gold only)
 */

export function useGetMyLikesReceived<
  TData = Awaited<ReturnType<typeof getMyLikesReceived>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyLikesReceived>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyLikesReceivedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Set or update own video intro (Gold only)
 */
export const getPutMyVideoIntroUrl = () => {
  return `/api/profiles/me/video-intro`;
};

export const putMyVideoIntro = async (
  updateVideoIntroRequest: UpdateVideoIntroRequest,
  options?: RequestInit,
): Promise<UpdateVideoIntroResponse> => {
  return customFetch<UpdateVideoIntroResponse>(getPutMyVideoIntroUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateVideoIntroRequest),
  });
};

export const getPutMyVideoIntroMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyVideoIntro>>,
    TError,
    { data: BodyType<UpdateVideoIntroRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMyVideoIntro>>,
  TError,
  { data: BodyType<UpdateVideoIntroRequest> },
  TContext
> => {
  const mutationKey = ["putMyVideoIntro"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMyVideoIntro>>,
    { data: BodyType<UpdateVideoIntroRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return putMyVideoIntro(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMyVideoIntroMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMyVideoIntro>>
>;
export type PutMyVideoIntroMutationBody = BodyType<UpdateVideoIntroRequest>;
export type PutMyVideoIntroMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Set or update own video intro (Gold only)
 */
export const usePutMyVideoIntro = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMyVideoIntro>>,
    TError,
    { data: BodyType<UpdateVideoIntroRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof putMyVideoIntro>>,
  TError,
  { data: BodyType<UpdateVideoIntroRequest> },
  TContext
> => {
  return useMutation(getPutMyVideoIntroMutationOptions(options));
};

/**
 * @summary Remove own video intro
 */
export const getDeleteMyVideoIntroUrl = () => {
  return `/api/profiles/me/video-intro`;
};

export const deleteMyVideoIntro = async (
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteMyVideoIntroUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMyVideoIntroMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyVideoIntro>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMyVideoIntro>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteMyVideoIntro"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyVideoIntro>>,
    void
  > = () => {
    return deleteMyVideoIntro(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMyVideoIntroMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyVideoIntro>>
>;

export type DeleteMyVideoIntroMutationError = ErrorType<unknown>;

/**
 * @summary Remove own video intro
 */
export const useDeleteMyVideoIntro = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyVideoIntro>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMyVideoIntro>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteMyVideoIntroMutationOptions(options));
};

/**
 * @summary Request a presigned URL for video intro upload (Gold only)
 */
export const getRequestVideoUploadUrlUrl = () => {
  return `/api/storage/uploads/video-request-url`;
};

export const requestVideoUploadUrl = async (
  videoUploadUrlRequest: VideoUploadUrlRequest,
  options?: RequestInit,
): Promise<VideoUploadUrlResponse> => {
  return customFetch<VideoUploadUrlResponse>(getRequestVideoUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(videoUploadUrlRequest),
  });
};

export const getRequestVideoUploadUrlMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestVideoUploadUrl>>,
    TError,
    { data: BodyType<VideoUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestVideoUploadUrl>>,
  TError,
  { data: BodyType<VideoUploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestVideoUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestVideoUploadUrl>>,
    { data: BodyType<VideoUploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestVideoUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestVideoUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestVideoUploadUrl>>
>;
export type RequestVideoUploadUrlMutationBody = BodyType<VideoUploadUrlRequest>;
export type RequestVideoUploadUrlMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Request a presigned URL for video intro upload (Gold only)
 */
export const useRequestVideoUploadUrl = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestVideoUploadUrl>>,
    TError,
    { data: BodyType<VideoUploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestVideoUploadUrl>>,
  TError,
  { data: BodyType<VideoUploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestVideoUploadUrlMutationOptions(options));
};

/**
 * @summary Admin-only — set the subscription tier of a user (testing)
 */
export const getDevSetTierUrl = () => {
  return `/api/dev/set-tier`;
};

export const devSetTier = async (
  setTierRequest: SetTierRequest,
  options?: RequestInit,
): Promise<SetTierResponse> => {
  return customFetch<SetTierResponse>(getDevSetTierUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setTierRequest),
  });
};

export const getDevSetTierMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof devSetTier>>,
    TError,
    { data: BodyType<SetTierRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof devSetTier>>,
  TError,
  { data: BodyType<SetTierRequest> },
  TContext
> => {
  const mutationKey = ["devSetTier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof devSetTier>>,
    { data: BodyType<SetTierRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return devSetTier(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DevSetTierMutationResult = NonNullable<
  Awaited<ReturnType<typeof devSetTier>>
>;
export type DevSetTierMutationBody = BodyType<SetTierRequest>;
export type DevSetTierMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Admin-only — set the subscription tier of a user (testing)
 */
export const useDevSetTier = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof devSetTier>>,
    TError,
    { data: BodyType<SetTierRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof devSetTier>>,
  TError,
  { data: BodyType<SetTierRequest> },
  TContext
> => {
  return useMutation(getDevSetTierMutationOptions(options));
};

/**
 * @summary Update notification and privacy settings
 */
export const getUpdateMySettingsUrl = () => {
  return `/api/profiles/me/settings`;
};

export const updateMySettings = async (
  updateSettingsRequest: UpdateSettingsRequest,
  options?: RequestInit,
): Promise<Profile> => {
  return customFetch<Profile>(getUpdateMySettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSettingsRequest),
  });
};

export const getUpdateMySettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMySettings>>,
    TError,
    { data: BodyType<UpdateSettingsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMySettings>>,
  TError,
  { data: BodyType<UpdateSettingsRequest> },
  TContext
> => {
  const mutationKey = ["updateMySettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMySettings>>,
    { data: BodyType<UpdateSettingsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMySettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMySettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMySettings>>
>;
export type UpdateMySettingsMutationBody = BodyType<UpdateSettingsRequest>;
export type UpdateMySettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update notification and privacy settings
 */
export const useUpdateMySettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMySettings>>,
    TError,
    { data: BodyType<UpdateSettingsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMySettings>>,
  TError,
  { data: BodyType<UpdateSettingsRequest> },
  TContext
> => {
  return useMutation(getUpdateMySettingsMutationOptions(options));
};

/**
 * @summary Read e-mail preferences via unsubscribe token (public, no auth)
 */
export const getGetUnsubscribePreferencesUrl = (
  params: GetUnsubscribePreferencesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/unsubscribe/preview?${stringifiedParams}`
    : `/api/unsubscribe/preview`;
};

export const getUnsubscribePreferences = async (
  params: GetUnsubscribePreferencesParams,
  options?: RequestInit,
): Promise<UnsubscribePreferences> => {
  return customFetch<UnsubscribePreferences>(
    getGetUnsubscribePreferencesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetUnsubscribePreferencesQueryKey = (
  params?: GetUnsubscribePreferencesParams,
) => {
  return [`/api/unsubscribe/preview`, ...(params ? [params] : [])] as const;
};

export const getGetUnsubscribePreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnsubscribePreferences>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetUnsubscribePreferencesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUnsubscribePreferences>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUnsubscribePreferencesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUnsubscribePreferences>>
  > = ({ signal }) =>
    getUnsubscribePreferences(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnsubscribePreferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUnsubscribePreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnsubscribePreferences>>
>;
export type GetUnsubscribePreferencesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Read e-mail preferences via unsubscribe token (public, no auth)
 */

export function useGetUnsubscribePreferences<
  TData = Awaited<ReturnType<typeof getUnsubscribePreferences>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetUnsubscribePreferencesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUnsubscribePreferences>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUnsubscribePreferencesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Submit feedback (optionalAuth)
 */
export const getSubmitFeedbackUrl = () => {
  return `/api/feedback`;
};

export const submitFeedback = async (
  submitFeedbackRequest: SubmitFeedbackRequest,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getSubmitFeedbackUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(submitFeedbackRequest),
  });
};

export const getSubmitFeedbackMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitFeedback>>,
    TError,
    { data: BodyType<SubmitFeedbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitFeedback>>,
  TError,
  { data: BodyType<SubmitFeedbackRequest> },
  TContext
> => {
  const mutationKey = ["submitFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitFeedback>>,
    { data: BodyType<SubmitFeedbackRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return submitFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitFeedback>>
>;
export type SubmitFeedbackMutationBody = BodyType<SubmitFeedbackRequest>;
export type SubmitFeedbackMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Submit feedback (optionalAuth)
 */
export const useSubmitFeedback = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitFeedback>>,
    TError,
    { data: BodyType<SubmitFeedbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitFeedback>>,
  TError,
  { data: BodyType<SubmitFeedbackRequest> },
  TContext
> => {
  return useMutation(getSubmitFeedbackMutationOptions(options));
};

/**
 * @summary List all feedback entries (admin only)
 */
export const getAdminListFeedbackUrl = () => {
  return `/api/feedback`;
};

export const adminListFeedback = async (
  options?: RequestInit,
): Promise<FeedbackEntry[]> => {
  return customFetch<FeedbackEntry[]>(getAdminListFeedbackUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListFeedbackQueryKey = () => {
  return [`/api/feedback`] as const;
};

export const getAdminListFeedbackQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListFeedback>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListFeedback>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListFeedbackQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListFeedback>>
  > = ({ signal }) => adminListFeedback({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListFeedback>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListFeedbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListFeedback>>
>;
export type AdminListFeedbackQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all feedback entries (admin only)
 */

export function useAdminListFeedback<
  TData = Awaited<ReturnType<typeof adminListFeedback>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListFeedback>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListFeedbackQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Apply an unsubscribe action via token (public, no auth)
 */
export const getApplyUnsubscribeUrl = () => {
  return `/api/unsubscribe/apply`;
};

export const applyUnsubscribe = async (
  unsubscribeApplyRequest: UnsubscribeApplyRequest,
  options?: RequestInit,
): Promise<UnsubscribePreferences> => {
  return customFetch<UnsubscribePreferences>(getApplyUnsubscribeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(unsubscribeApplyRequest),
  });
};

export const getApplyUnsubscribeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyUnsubscribe>>,
    TError,
    { data: BodyType<UnsubscribeApplyRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyUnsubscribe>>,
  TError,
  { data: BodyType<UnsubscribeApplyRequest> },
  TContext
> => {
  const mutationKey = ["applyUnsubscribe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyUnsubscribe>>,
    { data: BodyType<UnsubscribeApplyRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return applyUnsubscribe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyUnsubscribeMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyUnsubscribe>>
>;
export type ApplyUnsubscribeMutationBody = BodyType<UnsubscribeApplyRequest>;
export type ApplyUnsubscribeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Apply an unsubscribe action via token (public, no auth)
 */
export const useApplyUnsubscribe = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyUnsubscribe>>,
    TError,
    { data: BodyType<UnsubscribeApplyRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyUnsubscribe>>,
  TError,
  { data: BodyType<UnsubscribeApplyRequest> },
  TContext
> => {
  return useMutation(getApplyUnsubscribeMutationOptions(options));
};
